import { render, staticRenderFns } from "./HomeDocuments.vue?vue&type=template&id=29dda3bc"
import script from "./HomeDocuments.vue?vue&type=script&lang=js"
export * from "./HomeDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports